import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import css from "./Container.module.css";

const Container = React.forwardRef(
  (
    {
      variant = "default",
      as: Component = "div",
      className,
      children,
      ...rest
    },
    ref,
  ) => (
    <Component
      ref={ref}
      className={clsx(css.root, css[variant], className)}
      {...rest}
    >
      {children}
    </Component>
  ),
);

Container.displayName = "Container";

Container.propTypes = {
  variant: PropTypes.oneOf(["default", "narrow", "wide", "fluid"]),
  as: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Container;
